import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Toolbar from '../../common/Toolbar';
import ProductFilter from '../../filters/ProductFilter';
import styles from './ReplenishProducts.module.scss';
import DropDownFilter from '../../filters/DropDownFilter';
import { productsFilter } from '../../../constants/filters';
import Wall from '../../common/Wall';
import ThemeFilterRetailer from '../../../components/theme/ThemeFilterRetailer';
import Search from '../../common/Search';
import ThemeRetailer from '../../../components/theme/ThemeRetailer';
import WrapperColumnRetailers from '../../../components/grid-container/WrapperColumnRetailers';
import SortOrderFilter from '../../filters/SortOrderFilter';
import ReplenishProductCard from '../../common/ReplenishProductCard';
import Spinner from '../../common/Spinner';
import Box from '../../common/Box';
import BuyProductModal from '../BuyProductModal/BuyProductModal';
import { StaticFilters } from '../../../constants/staticFilters';

function ReplenishProducts(props) {
  const { modalProduct, marketingAssetsLink, isLoadingProducts = false } = props;

  const [buyProductModalOpen, setBuyProductModalOpen] = useState(false);

  const handlePageClick = (data) => {
    const offset = props.perPage * data.selected;
    props.setPage(offset);
  };

  const openModal = (model) => {
    props.buyProduct(model);
    setBuyProductModalOpen(true);
  };

  const closeModal = () => {
    setBuyProductModalOpen(false);
  };

  const validateCreditCard = () => {
    const { supplierId } = props;

    if (supplierId && !props.validatedCreditCard) {
      if (props.isAdmin) {
        return (
          <div className={styles.missing_credit_card}>
            <span>Please go to </span>
            <Link to={`/retailers/${props.retailerId}/admin/activation/${supplierId}`}>setting</Link>
            <span> and make sure you provide a valid payment method</span>
          </div>
        );
      } else {
        return (
          <div className={styles.missing_credit_card}>
            Your account requires a payment method - please contact your account admin
          </div>
        );
      }
    }
  };

  const renderProducts = () => {
    if (props.isLoading) {
      return (
        <div className={styles.spinner}>
          <Spinner />
        </div>
      );
    }

    if (!props.data?.length) {
      return <div className={styles.noProducts}>No Products</div>;
    }

    return props.data.map((item) => (
      <ThemeRetailer key={item.model}>
        <ReplenishProductCard product={item} openModal={openModal} modalProduct={modalProduct} modal />
      </ThemeRetailer>
    ));
  };

  return (
    <div className={styles.wrapperToolbar}>
      {validateCreditCard()}

      <Toolbar grow width={660} name="Place an order">
        <div className={styles.center}>
          <DropDownFilter
            values={props.brands.filter((item) => !!item.approved_for_replenishment)}
            onChange={props.setSupplierId}
            images
          />
        </div>
        <div className={styles.right}>
          <DropDownFilter staticPoint values={productsFilter} onChange={props.setSortOrderField} />
          <Wall />
          <SortOrderFilter onChange={props.setSortOrder} />
        </div>
      </Toolbar>

      <div className={styles.isHide}>
        <div className="row vertical-indent">
          <ThemeFilterRetailer>
            <Search searchQuery={props.searchQuery} search={props.productSearch} />
            <ProductFilter
              staticFilters={[StaticFilters.HAS_INVENTORY]}
              setFilter={props.setFilter}
              setFilterSearch={props.setFilterSearch}
            />

            {marketingAssetsLink && (
              <div className={styles.marketing_assets_link}>
                <Box>
                  <span>
                    Please find <strong>{props.supplierName}</strong> marketing assets{' '}
                  </span>
                  <a href={marketingAssetsLink} target="_blank" rel="noopener noreferrer">
                    here
                  </a>
                </Box>
              </div>
            )}
          </ThemeFilterRetailer>

          <WrapperColumnRetailers
            isLoadingProducts={isLoadingProducts}
            currentPage={props.offset / props.perPage}
            pageCount={props.pageCount}
            handlePageClick={handlePageClick}
          >
            {renderProducts()}
          </WrapperColumnRetailers>

          <BuyProductModal
            key={modalProduct ? modalProduct.model : 'no-product'}
            open={buyProductModalOpen}
            onClose={closeModal}
            product={modalProduct}
            updateCart={props.updateCart}
            cartsData={props.cartsData}
            retailerId={props.retailerId}
          />
        </div>
      </div>
    </div>
  );
}

export default ReplenishProducts;

ReplenishProducts.propTypes = {
  perPage: PropTypes.number.isRequired,
  filters: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  pageCount: PropTypes.number.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  setSortOrderField: PropTypes.func.isRequired,
  productSearch: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  brands: PropTypes.array.isRequired,
  buyProduct: PropTypes.func.isRequired,
  modalProduct: PropTypes.object,
  searchQuery: PropTypes.string.isRequired,
  offset: PropTypes.number.isRequired,
  setSupplierId: PropTypes.func.isRequired,
  updateCart: PropTypes.func.isRequired,
  isLoadingProducts: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  cartsData: PropTypes.object,
  retailerId: PropTypes.number.isRequired,
  supplierId: PropTypes.number.isRequired,
  validatedCreditCard: PropTypes.bool,
  isAdmin: PropTypes.bool,
};
